'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button, IconButton, TextField } from '@/shared/components/ui';
import { FeatherFilter, FeatherLayers, FeatherRotateCcw, FeatherSearch, FeatherUser, FeatherX } from '@subframe/core';
import type { LoteFiltersBarProps } from '../../types/lote.types';
const typeOptions = ['Individual', 'Lote'];
const statusOptions = ['Aguardando envio', 'Aguardando resposta', 'Em negociação', 'Pendência', 'Pausada'];
export function LoteFiltersBar(t0) {
  const $ = _c(64);
  const {
    filters,
    onSearchChange,
    onTypeToggle,
    onStatusToggle,
    onClearFilters,
    selectedCount,
    totalCount,
    onOpenDrawer
  } = t0;
  const hasActiveFilters = filters.type.length > 0 || filters.status.length > 0;
  const getTypeIcon = _temp;
  const t1 = totalCount === 1 ? "negocia\xE7\xE3o" : "negocia\xE7\xF5es";
  let t2;
  if ($[0] !== t1 || $[1] !== totalCount) {
    t2 = <span className="text-body font-body text-default-font">{totalCount} {t1}</span>;
    $[0] = t1;
    $[1] = totalCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== selectedCount) {
    t3 = selectedCount > 0 && <Badge variant="brand">{selectedCount} {selectedCount === 1 ? "selecionada" : "selecionadas"}</Badge>;
    $[3] = selectedCount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-3">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherFilter />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="max-md:text-sm">Mais filtros</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onOpenDrawer) {
    t7 = <Button variant="neutral-secondary" icon={t5} onClick={onOpenDrawer}>{t6}</Button>;
    $[10] = onOpenDrawer;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherSearch />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== filters.search || $[14] !== onSearchChange) {
    t9 = filters.search ? <IconButton variant="neutral-tertiary" icon={<FeatherX />} onClick={() => onSearchChange("")} size="small" /> : null;
    $[13] = filters.search;
    $[14] = onSearchChange;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onSearchChange) {
    t10 = e => onSearchChange(e.target.value);
    $[16] = onSearchChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== filters.search || $[19] !== t10) {
    t11 = <TextField.Input placeholder={"Buscar por cliente ou negocia\xE7\xE3o..."} value={filters.search} onChange={t10} />;
    $[18] = filters.search;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <div className="w-full max-w-sm"><TextField variant="outline" icon={t8} iconRight={t9} className="w-full">{t11}</TextField></div>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t7) {
    t13 = <div className="flex w-full items-center gap-3 sm:w-auto">{t7}{t12}</div>;
    $[24] = t12;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t4) {
    t14 = <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">{t4}{t13}</div>;
    $[27] = t13;
    $[28] = t4;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== hasActiveFilters || $[31] !== onClearFilters) {
    t15 = hasActiveFilters && <Button variant="neutral-tertiary" size="small" onClick={onClearFilters} icon={<FeatherRotateCcw />}>Limpar filtros</Button>;
    $[30] = hasActiveFilters;
    $[31] = onClearFilters;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15) {
    t16 = <div className="flex flex-wrap items-center gap-2">{t15}</div>;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-caption font-caption text-subtext-color">Tipo:</span>;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = filters.type.length === 0 ? "brand" : "neutral";
  let t19;
  if ($[36] !== filters.type || $[37] !== onTypeToggle) {
    t19 = () => {
      if (filters.type.length > 0) {
        filters.type.forEach(t => onTypeToggle(t));
      }
    };
    $[36] = filters.type;
    $[37] = onTypeToggle;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t18 || $[40] !== t19) {
    t20 = <Badge variant={t18} className="cursor-pointer transition-colors hover:bg-neutral-100" onClick={t19}>Ver todos</Badge>;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== filters.type || $[43] !== onTypeToggle) {
    t21 = typeOptions.map(type_0 => <Badge key={type_0} variant={filters.type.includes(type_0) ? "brand" : "neutral"} icon={getTypeIcon(type_0)} className="hover:border-brand-100 hover:bg-brand-100 cursor-pointer transition-colors" onClick={() => onTypeToggle(type_0)}>{type_0}</Badge>);
    $[42] = filters.type;
    $[43] = onTypeToggle;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = <div className="flex items-center gap-2">{t17}<div className="flex items-center gap-1.5">{t20}{t21}</div></div>;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="hidden h-4 w-px bg-neutral-200 sm:block" />;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className="text-caption font-caption text-subtext-color">Status:</span>;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== filters.status || $[51] !== onStatusToggle) {
    t25 = statusOptions.map(status => <Badge key={status} variant={filters.status.includes(status) ? "brand" : "neutral"} className="hover:border-brand-100 hover:bg-brand-100 cursor-pointer transition-colors" onClick={() => onStatusToggle(status)}>{status}</Badge>);
    $[50] = filters.status;
    $[51] = onStatusToggle;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t25) {
    t26 = <div className="flex items-center gap-2">{t24}<div className="flex items-center gap-1.5">{t25}</div></div>;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t22 || $[56] !== t26) {
    t27 = <div className="flex flex-wrap items-center gap-4">{t22}{t23}{t26}</div>;
    $[55] = t22;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t16 || $[59] !== t27) {
    t28 = <div className="flex flex-wrap items-center justify-between gap-4">{t16}{t27}</div>;
    $[58] = t16;
    $[59] = t27;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== t14 || $[62] !== t28) {
    t29 = <div className="flex w-full flex-col gap-4">{t14}{t28}</div>;
    $[61] = t14;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  return t29;
}
function _temp(type) {
  if (type === "Individual") {
    return <FeatherUser className="h-4 w-4" />;
  }
  return <FeatherLayers className="h-4 w-4" />;
}